import React from 'react';

import { HumanMessageContent } from '~/components/AiChat/components/Message/HumanMessageContent';
import { MessageLayout } from '~/components/AiChat/components/Message/MessageLayout';
import { MESSAGE_VARIANT, type MessageProps } from '~/components/AiChat/components/Message/MessageTypes';
import Text from '~/components/core/TextComponents/Text';
import { useCms } from '~/components/hooks/useCms';
import Avatar from '~/components/ui/atoms/Avatar';
import { getRelativeTimeText, serverDateTimeToLocalMoment } from '~/DateTimeUtils';
import cn from '~/Utils/cn';

export const HumanAvatar: React.FC<{ userName: string; className?: string }> = ({ userName, className }) => {
  return <Avatar className={cn(className, 'bg-blue-600 font-medium')}>{userName[0]}</Avatar>;
};

const HumanMessageHoverDate: React.FC<{ createdAt: string }> = ({ createdAt }) => {
  const dateToUse = serverDateTimeToLocalMoment(createdAt).toDate();
  const relativeDate = getRelativeTimeText(dateToUse);

  return (
    <div className="flex w-full opacity-0 transition-opacity group-hover:opacity-100">
      <Text className="text-slate-700" weight={Text.WEIGHTS.REGULAR} variant={Text.VARIANTS.XS}>
        {relativeDate}
      </Text>
    </div>
  );
};

interface HumanMessageProps extends MessageProps {
  contextDocumentIds: number[];
}

const HumanMessageComponent: React.FC<HumanMessageProps> = ({ exchange, contextDocumentIds }) => {
  const { user } = useCms();

  const firstName = user.first_name || user.username || '';

  return (
    <MessageLayout
      avatar={<HumanAvatar userName={firstName || 'U'} className="bg-blue-700" />}
      variant={MESSAGE_VARIANT.HUMAN}
      footer={exchange.createdAt ? <HumanMessageHoverDate createdAt={exchange.createdAt} /> : undefined}
    >
      <HumanMessageContent text={exchange.userInput} chatDocumentIds={contextDocumentIds} withDocuments />
    </MessageLayout>
  );
};

export const HumanMessage = React.memo(HumanMessageComponent);
